import { useState } from 'react';
import {v4 as uuidv4} from 'uuid';
import { BotService } from '../../services/BotService';
import { useSession } from '../../hooks/useSession';
import { BOT_VERSIONS } from '../../constants';
import { useTranslation } from 'react-i18next';
function PreviewChatPage({ onClose, chatbotInfo, environment }) {

    const { t } = useTranslation();

    const { session } = useSession();
    
    const [message, setMessage] = useState('')
    const [listMessages, setListMessages] = useState([])
    const [fakeTicketId ] = useState(uuidv4())

    const sendMessage = async(messageFromInteractive?: string) => {
        if(!messageFromInteractive && !message) return;

        const newMessage = {
            sendBy: 'me',
            type: 'TEXT',
            text: messageFromInteractive || message
        }

        setListMessages( list => list.concat([newMessage]))
        setMessage('')

        let data;
        if(chatbotInfo.version === BOT_VERSIONS.V2) {
            data = await flowV2(messageFromInteractive || message)
        } else {
            data = await flowV3(messageFromInteractive || message)
        }


        const response = data.messages.map( m => ({
            ...m,
            sendBy: fakeTicketId,
            node_type: data.type,
            node_id: data.node_id
        }))

        setListMessages( list => list.concat(response))

    }

    const flowV2 = async(message) => {
        const response  = await BotService.flowV2({
            token_auth: chatbotInfo.token,
            message: message,
            ambiente: environment,
            tt_id: fakeTicketId
        })
        
        // setFakeTicketId(response.tt_id)

        const getMessages = (msg) => {
            const chunks = msg.split('|').filter(c => c !== 'LISTA VOICES').map(c => {
                try {
                    return JSON.parse(c)
                } catch (error) {
                    return c
                }
            });
    
            return chunks;
        }


        let messages = getMessages( typeof response.message === 'string' ? response.message: response.message.join('|'));

        messages = messages.map( m => {

            if(typeof m === 'string') {
                return {
                    type: 'TEXT',
                    text: m,
                }
            } 

            return {
                type: m.footer === 'Boton' ? 'BUTTONS': 'LIST',
                [ m.footer === 'Boton' ? 'buttons': 'list']: {
                    header: m.title,
                    body: m.body,
                    footer: m.footer,
                    action: {
                        button: m.buttonText,
                        sections: {
                            title: m?.sections?.[0]?.title,
                            rows: m?.sections?.[0]?.rows?.map( r => r.title)
                        }
                    }
                },
            }
        })


        return {
            type: response.action,
            node_id: '-1',
            messages: messages
        }
    }

    const flowV3 = async(message) => {
        const { data }  = await BotService.flow({
            bot_id: chatbotInfo.bot_id,
            account_id: chatbotInfo.account_id,
            ticket_id: fakeTicketId,
            phone_number: "5544332211", 
            name: session.user_name,
            message: message,
            is_sandbox: environment === '1' ? true: false
        })

        return data;
    }

    const renderList = (message) => {
        return (
            <div>
                { message.list.header &&  <div className='fw-bold mb-2'>{message.list.header}</div>}
                <div>{message.list.body}</div>
                { message.list.footer &&  <div className='fw-lighter font-12 mt-2'><em>{message.list.footer}</em></div>}

                <div className='text-center'>
                    <div className="dropdown dropup d-grid">
                        <button type="button" className="btn btn-link pb-0" data-bs-toggle="dropdown" ><i className="bi bi-list-task"></i> {message.list.action.button}</button>

                        <div className="dropdown-menu w-100" >
                            <button className="dropdown-item disabled"  >{message.list.action.sections.title}</button>
                            {
                                message.list.action.sections.rows.map( (r, i) => (
                                    <div key={i}>
                                        <button  className="dropdown-item"  onClick={() => sendMessage(r?.text || r)}>{r?.text || r}</button>
                                        { message.list.action.sections.rows.length -1 > i && <div className="dropdown-divider"></div>}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderButtons = (message) => {
        return (
            <div>
                { message.buttons.header &&  <div className='fw-bold mb-2'>{message.buttons.header}</div>}
                <div>{message.buttons.body}</div>
                { message.buttons.footer &&  <div className='fw-lighter font-12 mt-2'><em>{message.buttons.footer}</em></div>}
            </div>
        )
    }

    const renderText = (message) => {
        return <div>{message.text}</div>
    }
    const renderImage = (message) => {
        return (
            <>
                <div className='bg-white '>
                    <img src={message.image.link} className='img-fluid' />
                </div>
            </>
        )
    }


    return (
        <>
            <div className="card-header bg-soft-info-alternative d-flex align-items-start">
                <button type="button" className="btn btn-ghost-light btn-icon ml-negative-1" style={{ height: 'auto' }} onClick={onClose}>
                    <i className="bi-x-lg text-dark"></i>
                </button>
                <div>
                    <h3 className="card-header-title">{t("platform.chatbot.preview-title")}</h3>
                    <p className="m-0"><small className="text-muted">{t("platform.chatbot.preview-p")}</small></p>
                </div>
            </div>

            <div className="card-body p-0 d-flex flex-column">
                <div className="p-3 flex-grow-1 " style={{ maxHeight: 680, overflowX: 'hidden' }}>

                    {
                        listMessages.map((m, i) => (
                            <div className="d-flex mb-4" key={i}>
                                {
                                    m.sendBy !== 'me' && (
                                        <span className="avatar avatar-lg avatar-white avatar-circle me-3 border">
                                            <span className="avatar-initials">🤖</span>
                                        </span>
                                    )
                                }
                                <div className={`chat-message-content ${ m.sendBy !== 'me' ? 'received': '' }`}>
                                    <div className="received-message-content text-white-dark border rounded-1 p-2">
                                        { m.type === 'TEXT' && renderText(m) }
                                        { m.type === 'IMAGE' && renderImage(m) }
                                        { m.type === 'LIST' && renderList(m) }
                                        { m.type === 'BUTTONS' && renderButtons(m) }
                                    </div>

                                    { m.type === 'BUTTONS' && (
                                        <>
                                            <div className='d-grid '>
                                                {m.buttons.action.sections.rows.map( (r, i) => {
                                                    if(typeof r === 'string') {
                                                        return <button key={i} type="button" className="btn btn-outline-primary btn-sm mt-2" onClick={() => sendMessage(r)}>{r}</button>
                                                    }
                                                    
                                                    return <button key={i} type="button" className="btn btn-outline-primary btn-sm mt-2" onClick={() => window.open(r.url, '_blank')}>{r.text}</button>
                                                })}
                                            </div>
                                        </>
                                    )}

                                    
                                </div>
                                {
                                    m.sendBy === 'me' && (
                                        <span className="avatar avatar-lg avatar-white avatar-circle ms-3 border">
                                            <span className="avatar-initials">👨‍💻</span>
                                        </span>
                                    )
                                }

                                
                            </div>
                        ))
                    }

                  
                </div>

                <div className="chat-message-body bg-soft-info-alternative">
                    <div className='d-flex align-items-center'>
                        <input type='text'  className='form-control form-control-lg me-2' value={message} onChange={ ({target: { value }}) => setMessage(value)} onKeyDown={ ({ key }) =>  key === 'Enter' ? sendMessage(): null } />
                        <button type="button" className="btn btn-primary btn-icon" onClick={() => sendMessage()}>
                            <i className="bi-send-fill"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PreviewChatPage